export var Regulations;
(function (Regulations) {
    Regulations[Regulations["None"] = 0] = "None";
    Regulations[Regulations["GDPR"] = 1] = "GDPR";
    Regulations[Regulations["CCPA"] = 2] = "CCPA";
})(Regulations || (Regulations = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJBLE1BQU0sQ0FBTixJQUFZLFdBSVg7QUFKRCxXQUFZLFdBQVc7SUFDckIsNkNBQUksQ0FBQTtJQUNKLDZDQUFJLENBQUE7SUFDSiw2Q0FBSSxDQUFBO0FBQ04sQ0FBQyxFQUpXLFdBQVcsS0FBWCxXQUFXLFFBSXRCIn0=